import { useAtom } from 'jotai';
import Script from 'next/script';
import { useEffect } from 'react';

import {
  isJQueryScriptLoadedAtom,
  isPaypleScriptLoadedAtom,
} from '@/state/pay/atoms';

const usePaypleScripts = () => {
  const [isJQueryScriptLoaded, setIsJQueryScriptLoaded] = useAtom(
    isJQueryScriptLoadedAtom,
  );
  const [isPaypleScriptLoaded, setIsPaypleScriptLoaded] = useAtom(
    isPaypleScriptLoadedAtom,
  );

  useEffect(() => {
    if (isJQueryScriptLoaded && isPaypleScriptLoaded) {
      return;
    }

    const interval = setInterval(() => {
      if (typeof (window as any).$ === 'function') {
        setIsJQueryScriptLoaded(true);
      }

      if (typeof (window as any).PaypleCpayAuthCheck === 'function') {
        setIsPaypleScriptLoaded(true);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [isJQueryScriptLoaded, isPaypleScriptLoaded]);

  const PaypleRelatedScripts = () => (
    <>
      <Script
        key="jquery"
        src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"
      />

      {isJQueryScriptLoaded && (
        <>
          {/* TODO: 두번째 식은 dev에서 테스트 끝나면 제거 */}
          {window.location.origin === 'https://www.salesclue.io' ||
          window.location.origin === 'https://app.salesclue.io' ||
          window.location.origin === 'https://dev.salesclue.io' ? (
            <Script
              key="payple"
              src="https://cpay.payple.kr/js/cpay.payple.1.0.1.js"
            />
          ) : (
            <Script
              key="payple"
              src="https://democpay.payple.kr/js/cpay.payple.1.0.1.js"
            />
          )}
        </>
      )}
    </>
  );

  return {
    PaypleRelatedScripts,
    isAllScriptsReady: isJQueryScriptLoaded && isPaypleScriptLoaded,
  };
};

export default usePaypleScripts;
